<template>
	<div style="padding: 10px 10px 10px 0;">
		<el-dialog title="详情" :visible.sync="show" width="30%">
			<div class="flex">
				<div class="box">
					<div><span> 商铺号 ：</span><span>{{ obj.shopNum }}</span></div>
					<div><span>商铺名称 ：</span><span>{{ obj.shopName }}</span></div>
					<div><span> 申请人 ：</span><span>{{ obj.applyName }}</span></div>
					<div><span>联系方式 ：</span><span>{{ obj.phone }}</span></div>
					<div><span>申请时间 ：</span><span>{{ obj.applyTime.split("T")[0] }}</span></div>
					<div><span>退租原因 ：</span><span>{{ obj.returnReason }}</span></div>
					<div><span>退租类型 ：</span><span>{{ obj.type }}</span></div>
					<div>
						<span>附件 ：</span>
						<div v-if="obj.fileRes">
							<div @click="downFil(item)" style="color: #3C98FF;cursor: pointer;margin: 5px 0;"
								v-for="item in obj.fileRes">{{ item.name }}</div>
						</div>
					</div>
				</div>
				<el-timeline>
					<el-timeline-item>
						{{ obj.applyName }}
					</el-timeline-item>
					<el-timeline-item>
						商管{{ obj.result }}
					</el-timeline-item>
					<el-timeline-item>
						{{ obj.result }}
					</el-timeline-item>
				</el-timeline>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="show = false">关 闭</el-button>
			</span>
		</el-dialog>
		<el-form :inline="true" :model="form" class="demo-form-inline">
			<div class="flex sb">
				<div>
					<el-form-item label="商铺号">
						<el-input v-model="form.shopNum" placeholder="商铺号" style="width: 100px;"></el-input>
					</el-form-item>
					<el-form-item label="商铺名称">
						<el-input v-model="form.shopName" placeholder="商铺名称" style="width: 100px;"></el-input>
					</el-form-item>
					<el-form-item label="申请人">
						<el-select v-model="form.applyId" placeholder="申请人" style="width: 120px;">
							<el-option v-for="item in users" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="手机号">
						<el-input v-model="form.phone" placeholder="手机号" style="width: 120px;"></el-input>
					</el-form-item>
					<el-form-item label="状态">
						<el-select v-model="form.result" placeholder="状态" style="width: 100px;">
							<el-option label="审核中" value="审核中"></el-option>
							<el-option label="已拒绝" value="已拒绝"></el-option>
							<el-option label="已同意" value="已同意"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="类型">
						<el-select v-model="form.type" placeholder="类型" style="width: 100px;">
							<el-option label="正常" value="正常"></el-option>
							<el-option label="违规" value="违规"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="getAll">查询</el-button>
						<el-button type="primary" @click="cz">重置</el-button>
						<el-button type="primary" @click="dc">导出</el-button>

					</el-form-item>
				</div>
				<div>
				</div>
			</div>
		</el-form>
		<el-table :data="data" style="width: 100%" border>
			<el-table-column prop="shopNum" label="商铺号"></el-table-column>
			<el-table-column prop="shopName" label="商铺名称"></el-table-column>
			<el-table-column prop="returnReason" label="退租原因"></el-table-column>
			<el-table-column prop="applyName" label="申请人"></el-table-column>
			<el-table-column prop="phone" label="联系方式">
				<template slot-scope="{row}">{{ row.phone ? row.phone : "无" }}</template>
			</el-table-column>
			<el-table-column prop="result" label="状态"></el-table-column>
			<el-table-column prop="type" label="类型"></el-table-column>
			<el-table-column prop="date" label="操作">
				<template slot-scope="{row}">
					<el-button type="text" @click="lookRow(row)">查看</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination :page-sizes="[10, 20, 30, 50]" :page-size="form.pageSize" @size-change="handleSizeChange"
			@current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="count">
		</el-pagination>
	</div>
</template>

<script>
import publicExport from '../../assets/js/publicExport.js';
import downloadFile from '../../assets/js/downloadFile.js';
export default {
	data() {
		return {
			count: 0,
			users: [], //申请人
			show: false,
			form: {
				"applyId": "", //申请人id
				"phone": "", //联系电话
				"result": "", //状态
				"shopName": "", //商铺名称
				"shopNum": "", //商铺号
				"type": "", //类型（正常，违规）
				"currentPage": 0,
				"pageSize": 0,
			},
			addForm: {},
			data: [],
			obj: {
				fileRes: "",
				applyTime: ""
			}, //详情数据
		}
	},
	methods: {
		cz() {
			this.form = {
				"applyId": "", //申请人id
				"phone": "", //联系电话
				"result": "", //状态
				"shopName": "", //商铺名称
				"shopNum": "", //商铺号
				"type": "", //类型（正常，违规）
				"currentPage": 0,
				"pageSize": 0,
			}
			this.getAll()
		},
		downFil(item) {
			downloadFile(item)
		},
		lookRow(obj) {
			this.$http.get(`/api/bdShopReturn/getShopReturn?id=${obj.id}`).then(res => {
				this.obj = res.data.data
				this.show = true;
			})
		},
		handleCurrentChange(val) {
			this.form.currentPage = val;
			this.getAll()
		},
		handleSizeChange(val) {
			this.form.pageSize = val;
			this.getAll()
		},
		dc() {
			publicExport("/api/bdShopReturn/exportShopReturn", this.form, "商铺退租")
		},
		getUsers() { //查询申请人
			this.$http.get("/api/bdShopRenovation/getUserShop").then(res => {
				this.users = res.data.data
			})
		},
		getAll() { //获取表格数据
			this.$http.post("/api/bdShopReturn/queryShopReturn", this.form).then(res => {
				this.count = res.data.data.totalNum;
				this.data = res.data.data.items
			})
		}
	},
	created() {
		this.getAll();
		this.getUsers();
	}
}
</script>

<style scoped="scoped">
.box {
	font-size: 16px;
	width: 70%;
}

.box>div {
	margin-bottom: 10px;
}
</style>
